/**
 * DASHBOARD-QUESTION-OPEN-SKELETON.WIDGET
 * Skeletons adaptés à dashboard-question-open.widget.tsx : le corps de l'onglet « Tous les commentaires »
 * (étiquettes de mots, recherche, filtre par couleur, commentaires) et celui du résumé IA (quelques lignes).
 */
import Skeleton from "@/components/skeleton"

const TAG_WIDTHS = [86, 104, 118, 98, 72, 64, 92, 88, 76, 110]

export default function DashboardQuestionOpenSkeletonWidget() {
  return (
    <div style={{ padding: "4px 0 16px" }}>
      <div className="flex flex-wrap" style={{ gap: 8, padding: "0px 20px" }}>
        {TAG_WIDTHS.map((width, i) => (
          <Skeleton key={i} width={width} height={24} borderRadius={12} />
        ))}
      </div>

      <div className="flex" style={{ margin: "28px 20px 24px", alignItems: "flex-end" }}>
        <div>
          <Skeleton width={70} height={11} style={{ marginBottom: 8 }} />
          <Skeleton width={300} height={36} borderRadius={6} />
        </div>
        <div style={{ flex: 1 }} />
        <div className="flex" style={{ gap: 8 }}>
          {[0, 1, 2, 3].map((i) => (
            <Skeleton key={i} width={22} height={22} isCircle />
          ))}
        </div>
      </div>

      {[260, 190, 330].map((width, i) => (
        <div key={i} className="flex" style={{ padding: "18px 20px", gap: 16, borderTop: "1px solid #f0f0f0" }}>
          <Skeleton width={32} height={32} isCircle />
          <div style={{ flex: 1 }}>
            <Skeleton width={width} height={14} />
            <Skeleton width={Math.round(width * 0.6)} height={12} style={{ marginTop: 10 }} />
          </div>
          <Skeleton width={12} height={8} />
        </div>
      ))}
    </div>
  )
}

//Résumé IA : le paragraphe d'introduction et quelques lignes
export function DashboardQuestionOpenSummarySkeletonWidget() {
  return (
    <div style={{ padding: "8px 0 16px" }}>
      <Skeleton width="92%" height={13} />
      <Skeleton width="85%" height={13} style={{ marginTop: 10 }} />
      <Skeleton width="60%" height={13} style={{ marginTop: 10 }} />
    </div>
  )
}
